import React, { Component } from 'react';
import { Alert, Box, Typography } from "@mui/material";
import { useState } from "react";
import Dialog from '../../../common/Dialog';
import { QrReader } from 'react-qr-reader';
import _, { isEmpty } from 'lodash';

const ScanQrCodeReturn = (props) => {
	const [data, setData] = useState({});
	const [loan, setLoan] = useState({});
	const [err, setError] = useState("");

	const handleScan = (data) => {
		const { equipement_type, VEHICULES, EQUIPEMENTS } = props;
		let id = data.split("/").pop()
		let field = ""

		console.log('====================================');
		console.log(id, data.split("/"));
		console.log('====================================');
		let equip = {}
		if (id ) {
			if (equipement_type === "vehicule") {
				equip = VEHICULES[id]
				field = "loan_vehicule"
			}
			if (equipement_type === "equipement") {
				equip = EQUIPEMENTS[id]
				field = "loan_equipement"
			}
		}
		if ( equip ) {
			let loanInfo = findLoan(id, field)
			if (loanInfo) {
				setLoan(loanInfo)
			} else {
				setError("Aucun emprunt trouvé, Impossible de restituer l'équipement")
			}
			setData(equip)
		} else {
			setError("Equipement Introuvable")
		}
	};
	const findLoan = (id, field) => {
		const { LOANS } = props;
		
		let result = _.find(Object.values(LOANS), obj => (obj[field] === id && !obj.is_over) )
	
		console.log('====================================');
		console.log({result});
		console.log('====================================');

		return result
	};
	const handleEquipement = () => {
		let equip = {
			label: `${data.equipement_ref.toUpperCase()} | ${data.equipement_name}`,
			value: data.equipement_id,
			permanent: data.permanent_loan,
			equipement: data
		}
		let uInfo = props.USERS[loan.loan_user]
		let user = {
			label: `${uInfo.lastname.toUpperCase()} ${uInfo.username}`,
			value: uInfo.user_id
		}
		props.setEquipement(equip)
		// props.setUser(user)
		// props.setLoan(loan)
		props.handleClose()
	};

	return (
		<Dialog
			close={props.handleClose}
			title={props.title}
			submitAction={(loan && !loan.is_over) && handleEquipement}
		>
			<Box >
				
				{(!isEmpty(data) || err )? 
					<Box>
						{err ?
							<Alert severity="error">{err}</Alert>
						:
							<Box>
								<Box>
									<Typography variant="h6">{data.equipement_name}</Typography>
								{/* </Box>
								<Box> */}
									<Typography variant="button" color="primary" style={{ fontWeight: "bold"}} >Référence {data.equipement_ref}</Typography>
								</Box>
								<Box p={1} />
								<Box>
									<Typography variant="subtitle">Disponible : {data.equipement_available ? "Oui" : "Non"}</Typography>
								</Box>
								<Box>
									<Typography variant="subtitle">Utilisateur actuel : {loan && props.USERS && `${props.USERS[loan.loan_user].username} ${props.USERS[loan.loan_user].lastname}` }</Typography>
								</Box>
								{data.equipement_available &&
									<Box p={1}>
										<Alert severity="warning">Cet équipement est déjà disponible, Impossible de le restituer</Alert>
									</Box>
								}
							</Box>
						}
					</Box>
				:
					<QrReader
						onResult={
							(result, error) => {
								if (!!result) {
									handleScan(result?.text)
								}

								if (!!error) {
									console.info(error);
								}
							}
						}
						style={{ width: '100%' }}
					/>
					
				}
			</Box>
		</Dialog>
	);
};

export default ScanQrCodeReturn;
